export enum FeatureToggleNames {
  RELEASE_LLM_CONVERSATIONS = 'release_dev-7973-llm-conversations',
  // for unit tests
  UNIT_TEST = 'unit_test',
  RELEASE_INSTALL_PWA = 'release_dev-9604_install-pwa',
  RELEASE_SEARCH_SUMMARY = 'release_dev-9903_search-ai-summary',
  RELEASE_BROWSER_EXTENSION_WIDGET = 'release_dev-10213_browser-extension-widget',
  RELEASE_STRATEGIC_FORESIGHT = 'release_dev-10104_strategic-foresight',
  RELEASE_DEV_11385_KI_ADMIN_NAV = 'release_dev-11385_ki-admin-nav',
  RELEASE_DEV_10770_LLM_CONCEPT_FILTERING_MVP = 'release_dev-10770_llm-concept-filtering-mvp',
  RELEASE_STARDEV_11519_AGENT_ROLLOUT = 'release_stardev-11519_agent-rollout',
  RELEASE_STARDEV_11410_MCP_INSTALL = 'release_stardev-11410_mcp-install',
  CONNECTIONS_MAP_DEMO = 'connections_map_demo',
  RELEASE_NOJIRA_PKCE_AUTH = 'release_nojira_pkce-auth'
}
